import LeftNavigationPanel from './LeftNavigationPanel';

export default LeftNavigationPanel;
